var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoyballonfly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 112,
    viewBox: "0 0 104 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3645 7.78383C43.3886 10.681 45.4932 14.5412 44.162 17.0304C42.69 19.7815 37.5539 19.857 32.4696 17.2923L32.4682 17.2943C26.9755 23.4598 20.7812 27.8711 15.3848 30.9229C16.5959 32.7397 18.0693 34.6251 19.8378 36.579C21.344 38.2418 23.199 39.8042 25.2651 41.1668C33.308 36.4081 42.8155 28.6906 49.1177 16.7546C48.8295 16.1528 48.5305 15.5649 48.2183 14.9934C47.3658 13.4271 46.4239 11.978 45.4029 10.6855C43.9275 8.81796 42.2454 7.21732 40.4119 5.89844C40.0734 6.53949 39.7245 7.16762 39.3654 7.78234L39.3645 7.78383Z",
    fill: "#9FD962"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 16.431C10.3648 20.5447 11.6878 25.4142 15.3797 30.9258C20.7761 27.8741 26.9709 23.4627 32.4631 17.2972L32.4645 17.2952C32.2315 17.1774 31.999 17.0567 31.7664 16.928C26.4628 13.9925 23.4113 9.28006 24.9502 6.40278C26.4896 3.52549 32.0366 3.57221 37.3402 6.50763C38.0564 6.90419 38.7306 7.33404 39.3589 7.78626L39.3599 7.78477C39.7194 7.17005 40.0683 6.54242 40.4063 5.90087C40.2993 5.81987 40.1889 5.74135 40.079 5.66283C36.0734 2.86108 31.3986 1.35734 26.6636 1.21919C26.3236 1.20876 25.983 1.20429 25.6445 1.20876L25.6469 1.21224C21.399 8.19474 15.3631 13.2054 10.3125 16.431Z",
    fill: "#FF544D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2617 41.17C30.0231 44.3057 35.912 46.3784 41.3109 46.1588C45.4606 42.8755 49.6068 38.7897 53.2133 33.7631C53.0545 27.931 51.5517 21.8594 49.1149 16.7578C42.8122 28.6938 33.3046 36.4118 25.2617 41.17Z",
    fill: "#677BD7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3105 46.1574C45.789 45.9775 49.9231 44.2248 52.8026 40.2006C53.1323 38.2287 53.2643 36.1619 53.2218 34.0644C53.2174 33.9645 53.2169 33.8616 53.2125 33.7617C49.6065 38.7883 45.4602 42.8741 41.3105 46.1574Z",
    fill: "#FFC155"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3142 16.4293C15.3647 13.2037 21.4007 8.19252 25.6496 1.21051L25.6471 1.20703C21.8297 1.24877 18 2.18203 14.4834 4.03959C12.5786 6.54367 10.2409 10.7726 10.3142 16.4293Z",
    fill: "#FFC155"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4968 47.4644C13.8574 46.7095 19.1352 44.7993 25.26 41.1736C23.194 39.811 21.339 38.2486 19.8328 36.5859C18.0643 34.6319 16.5908 32.7465 15.3797 30.9297C9.87824 34.0455 5.20726 35.748 2.95898 36.476C3.83592 38.588 5.01574 40.6155 6.49896 42.4925C7.28991 43.4938 8.17615 44.4668 9.15226 45.4041C9.88898 46.1132 10.6692 46.8029 11.4968 47.4644Z",
    fill: "#95CA54"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3158 16.4336C6.42066 18.9218 3.1098 20.35 1.65785 20.8136C1.65492 20.8161 1.6549 20.8161 1.6549 20.8161C0.559581 25.5957 0.829261 30.6684 2.53135 35.3745C2.66716 35.7422 2.80836 36.1109 2.96225 36.4747C5.21053 35.7462 9.88151 34.0437 15.383 30.9283C11.6911 25.4168 10.3681 20.5473 10.3158 16.4336Z",
    fill: "#FF4242"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2613 41.1719C19.1359 44.7975 13.8587 46.7073 11.498 47.4626C15.6551 50.815 20.8448 53.5188 26.1363 54.9972C26.2946 55.042 26.4563 55.0837 26.6175 55.126C30.7765 53.2217 36.0425 50.3364 41.3104 46.1607C35.9115 46.3803 30.0227 44.3081 25.2613 41.1719Z",
    fill: "#566FB8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3121 46.1604C36.0446 50.3362 30.7781 53.222 26.6191 55.1257C33.1349 56.8546 39.7634 56.7015 44.769 53.5882C45.3274 53.2458 45.8639 52.8617 46.3773 52.4423C46.8908 52.0223 47.3749 51.5726 47.8234 51.0911C50.505 48.2516 52.1021 44.438 52.8041 40.2031C49.9246 44.2273 45.7906 45.9805 41.3121 46.1604Z",
    fill: "#FFB44A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M14.483 4.04297C13.0315 4.80527 11.6372 5.7276 10.3181 6.80596C5.95103 10.376 3.07596 15.1367 1.78328 20.2621C1.73735 20.441 1.69436 20.6234 1.65625 20.8122C3.1082 20.3486 6.41857 18.9209 10.3142 16.4322C10.2405 10.7755 12.5781 6.54655 14.483 4.04297Z",
    fill: "#FFB44A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M46.731 54.6298C46.731 54.6298 45.7994 60.3143 48.7228 55.411C54.0621 53.5594 48.4043 53.2617 48.4043 53.2617C48.2303 53.5017 47.9832 53.7641 47.6417 54.0429C47.3007 54.3217 46.9958 54.511 46.731 54.6298Z",
    fill: "#FF544D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7676 53.5826C44.7676 53.5826 45.134 55.3392 46.7315 54.6266C46.9963 54.5084 47.3012 54.319 47.6422 54.0397C47.9832 53.761 48.2308 53.4986 48.4048 53.2586C49.4327 51.8254 47.8219 51.0859 47.8219 51.0859C47.3734 51.567 46.8893 52.0172 46.3759 52.4371C45.8624 52.8565 45.3265 53.2402 44.7676 53.5826Z",
    fill: "#FF544D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1611 17.0278C45.4924 14.5391 43.3877 10.6784 39.3636 7.78125C37.3024 11.3369 34.9584 14.4929 32.4688 17.2897C37.553 19.8549 42.6896 19.7794 44.1611 17.0278Z",
    fill: "#B4E878"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3455 6.50619C32.0419 3.57076 26.4945 3.52356 24.9555 6.40134C23.4161 9.27862 26.4681 13.9911 31.7717 16.9265C32.0038 17.0552 32.2368 17.176 32.4698 17.2938C34.9594 14.497 37.3035 11.3409 39.3647 7.78531C38.7354 7.3326 38.0617 6.90275 37.3455 6.50619Z",
    fill: "#FF6A68"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4017 10.6868C46.4227 11.9794 47.3647 13.4284 48.2172 14.9948C51.2242 20.5059 53.0928 27.4531 53.2247 34.0639C53.3713 41.4241 51.3658 48.3619 46.3783 52.4392C41.1245 56.7343 33.5349 57.0583 26.1389 54.994C19.8025 53.2219 13.6097 49.6956 9.15613 45.3991C8.18001 44.4614 7.29378 43.4889 6.50283 42.4875C4.76361 40.2866 3.44406 37.8784 2.53195 35.3708C0.762928 30.4849 0.542117 25.2039 1.78595 20.2599C3.07864 15.1339 5.95371 10.3738 10.3208 6.80374C15.133 2.86996 20.9437 1.04619 26.6685 1.21813C31.4034 1.35628 36.0788 2.86002 40.0839 5.66227C42.042 7.03034 43.8374 8.70702 45.4017 10.6868Z",
    stroke: "#333F61",
    strokeWidth: 1.2847,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8249 51.0938C47.8249 51.0938 50.0204 52.1025 47.6441 54.0451C45.2683 55.9876 44.7715 53.5894 44.7715 53.5894",
    stroke: "#333F61",
    strokeWidth: 1.2847,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4045 53.2617C48.4045 53.2617 54.0648 53.5614 48.725 55.4115C45.8006 60.3178 46.7303 54.6308 46.7303 54.6308",
    stroke: "#333F61",
    strokeWidth: 1.2847,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65625 20.8161C1.65625 20.8161 1.65626 20.8161 1.65968 20.8132C4.99595 19.7562 18.13 13.5827 25.6531 1.21484",
    stroke: "#161616",
    strokeWidth: 0.4282,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96289 36.4692C8.58945 34.6489 29.3755 26.7083 40.4108 5.89844",
    stroke: "#161616",
    strokeWidth: 0.4282,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.498 47.4608C16.9658 45.7105 38.0177 37.7809 49.1145 16.7578",
    stroke: "#161616",
    strokeWidth: 0.4282,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6191 55.1227C34.0514 51.7231 45.0285 45.1754 53.2145 33.7617",
    stroke: "#161616",
    strokeWidth: 0.4282,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5002 55C49.5002 55 43.612 70.7917 47.0002 80C54.4321 100.198 93.3758 56.7813 102 76.5C107.655 89.4304 93.0002 111.5 93.0002 111.5",
    stroke: "#333F61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoyballonfly);
export default __webpack_public_path__ + "static/media/boyballonfly.3e0308c2b252d8b3798679ef031aff9e.svg";
export { ForwardRef as ReactComponent };